import type { StorageProviderKey } from "@/shared/storage-contracts";

export type { StorageProviderKey };

export type StorageUrlMode = "public";

export interface StorageMigrationConfig {
  writeTarget: StorageProviderKey;
}

export const getStorageMigrationConfig = (): StorageMigrationConfig => ({
  writeTarget: "r2",
});

export interface CanonicalStorageMetadata {
  provider: StorageProviderKey;
  key: string;
  urlMode: StorageUrlMode;
}

export interface CanonicalStorageMetadataDB {
  storage_provider: StorageProviderKey;
  storage_key: string;
  storage_url_mode: StorageUrlMode;
}

export const toCanonicalStorageMetadataDB = (
  metadata: CanonicalStorageMetadata
): CanonicalStorageMetadataDB => ({
  storage_provider: metadata.provider,
  storage_key: metadata.key,
  storage_url_mode: metadata.urlMode,
});

export const fromStorageRecord = (
  row: { storage_provider?: string | null; storage_key?: string | null; storage_url_mode?: string | null; file_path?: string | null }
): CanonicalStorageMetadata => ({
  provider: "r2",
  key: row.storage_key || row.file_path || "",
  urlMode: "public",
});
